var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "url(#paint0_linear_355_35)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67898 3.01989C2.56723 3.01989 2.46804 3.00024 2.38139 2.96094C2.29522 2.92116 2.22727 2.86648 2.17756 2.79688C2.12831 2.72727 2.10322 2.64725 2.10227 2.55682H2.4858C2.48722 2.60701 2.50663 2.64702 2.54403 2.67685C2.58191 2.70668 2.62689 2.72159 2.67898 2.72159C2.71922 2.72159 2.75473 2.71307 2.78551 2.69602C2.81629 2.6785 2.84044 2.65388 2.85795 2.62216C2.87547 2.59044 2.884 2.5535 2.88352 2.51136C2.884 2.46875 2.87547 2.43182 2.85795 2.40057C2.84044 2.36884 2.81629 2.34446 2.78551 2.32741C2.75473 2.3099 2.71922 2.30114 2.67898 2.30114C2.63731 2.30114 2.59872 2.31132 2.56321 2.33168C2.52817 2.35156 2.50237 2.37926 2.4858 2.41477L2.1392 2.34659L2.19602 1.54545H3.1733V1.8608H2.51989L2.49148 2.18182H2.5C2.52273 2.13778 2.56203 2.10133 2.6179 2.07244C2.67377 2.04309 2.73864 2.02841 2.8125 2.02841C2.89915 2.02841 2.97633 2.04853 3.04403 2.08878C3.11222 2.12902 3.16596 2.18466 3.20526 2.25568C3.24503 2.32623 3.26468 2.40767 3.2642 2.5C3.26468 2.60133 3.24053 2.69129 3.19176 2.76989C3.14347 2.84801 3.07552 2.90933 2.98793 2.95384C2.90033 2.99787 2.79735 3.01989 2.67898 3.01989Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_35",
    x1: 1.13281,
    y1: 0.364583,
    x2: 3.6849,
    y2: 4.71354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.435612,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579359,
    stopColor: "#8F00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall5);
export default __webpack_public_path__ + "static/media/ball5.8817ea8110e38d5e0306465c3ba08afe.svg";
export { ForwardRef as ReactComponent };